<template>
  <div>
      <v-dialog
        v-model="selectMenuDialog"
        max-width="176px"
        scrollable
      elevation="1"
      >
      <div class="modal-wrapper" @click.self="menuOff">
        <v-card>
          <v-btn
            color="primary"
          style="font-size: 24px"
            class="ma-2"
            width="160"
          height="50"
            @click="edit"
            >編集</v-btn
          >
          <v-btn
            color="primary"
          style="font-size: 24px"
            class="ma-2"
            width="160"
          height="50"
            @click="copy"
            >コピー</v-btn
          >
          <v-btn
            color="primary"
          style="font-size: 24px"
            class="ma-2"
            width="160"
          height="50"
            @click="del"
            >削除</v-btn
          >
        </v-card>
      </div>
      </v-dialog>
    <!-- ダイアログ -->
    <confirm-dialog ref="confirm_delete_info" @on-click-ok="deleteInfo"
      >削除しますか？</confirm-dialog
    >
  </div>
</template>

<script>
import Api from "@/logic/api/api.js";
import AlertBuilder from "../../logic/common/alert-contents";
import valueMapper from "../../logic/common/value-mapper";
import ConfirmDialog from "../../components/dialog/confirmWkReg.vue";

export default {
  components: {
    "confirm-dialog": ConfirmDialog,
  },
  props: ["jsonBody", "recordId"],
  data() {
    return {
      selectMenuDialog: false,
    };
  },
  methods: {
    /**
     * ダイアログを表示する
     */
    showMenu() {
      this.selectMenuDialog = true;
    },
    /**
     * 区画漁業権番号関連初期化
     */
    initSectionalFisherNumber() {
      // 採取海域区分退避
      this.checkSeaAreaRsv = this.checkSeaArea;
      // 区画漁業権番号項目内容クリア
      this.sectionalFisherNumber = "";
      // 海域区分項目内容クリア
      this.seaareaClass = "";
    },
    /**
     * 編集処理
     */
    edit() {
      // JSON情報を準備
      var bodyData = encodeURIComponent(JSON.stringify(this.jsonBody));
      var id = encodeURIComponent(JSON.stringify(this.recordId));
      var mode = encodeURIComponent(JSON.stringify("EDIT"));
      // 編集を実行(JSON情報を送信)
      switch (this.jsonBody.type) {
        case "WORKLOG":
          // 作業記録
          this.$router.push(`/worklog/${id}/edit`);
          break;
        case "UNLOADING":
          // 水揚げ
          this.$router.push(`/unloading/${bodyData}/${id}/${mode}`);
          break;
        case "SHIPPING":
          // 加工・出荷
          this.$router.push(`/shipping/${bodyData}/${id}/${mode}`);
          break;
        case "SEAWATER":
          // 使用海水
          this.$router.push(`/seawater/${bodyData}/${id}/${mode}`);
          break;
        default:
          break;
      }
      // メニュー画面を閉じる
      this.menuOff();
    },
    /**
     * コピー処理
     */
    copy() {
      // JSON情報を準備
      var bodyData = encodeURIComponent(JSON.stringify(this.jsonBody));
      var id = encodeURIComponent(JSON.stringify(this.recordId));
      var mode = encodeURIComponent(JSON.stringify("COPY"));
      // コピーを実行(JSON情報を送信)
      switch (this.jsonBody.type) {
        case "WORKLOG":
          // 作業記録
          this.$router.push(`/worklog/${id}/copy`);
          break;
        case "UNLOADING":
          // 水揚げ
          this.$router.push(`/unloading/${bodyData}/${id}/${mode}`);
          break;
        case "SHIPPING":
          // 加工・出荷
          this.$router.push(`/shipping/${bodyData}/${id}/${mode}`);
          break;
        case "SEAWATER":
          // 使用海水
          this.$router.push(`/seawater/${bodyData}/${id}/${mode}`);
          break;
        default:
          break;
      }
      // メニュー画面を閉じる
      this.menuOff();
    },
    /**
     * 削除処理(確認ダイアログ表示)
     */
    del() {
      // メニュー画面を閉じる
      this.menuOff();
      // 削除確認ダイアログを表示する
      this.$refs.confirm_delete_info.showDialog();
    },
    /**
     * 削除処理
     */
    deleteInfo() {
      // 生産情報削除
      let updateUrl = "/haccp/record/update";
      let postData = this.buildDeleteData();

      if (this.jsonBody.type === "WORKLOG") {
        updateUrl = "/work/record/update";
      }

      this.$store.commit("setWaiting", true);

      Api.call(updateUrl, postData)
        .then(() => {
          this.$store.commit("setWaiting", false);
          this.$router.push("/product");
        })
        .catch((error) => {
          this.$store.commit("setWaiting", false);
          const message = valueMapper
            .map({
              400: AlertBuilder.error("削除できませんでした"),
              401: AlertBuilder.invalid(),
              403: AlertBuilder.error("権限がありません"),
            })
            .getOrElse(error.status, AlertBuilder.invalid());
          if (message.isInvalid) {
            Api.resolve(error);
          } else {
            this.$emit('pushMessage', message);
          }
        });
    },
    /**
     * 削除用送信データを画面から取得する(水揚げ／加工・出荷／使用海水共通)
     */
    buildDeleteData() {
      let today = new Date();
      let year = today.getFullYear();
      let month = ("0" + (today.getMonth() + 1)).slice(-2);
      let date = ("0" + today.getDate()).slice(-2);
      let record_date = year + "/" + month + "/" + date;

      return {
        record_type: "DELETED",
        record_date: record_date,
        body: this.buildbodyBodyData(),
        record_id: this.recordId,
      };
    },
    /**
     * 格納データを作成する(削除時は中身空でOK)
     */
    buildbodyBodyData() {
      switch (this.jsonBody.type) {
        case "WORKLOG":
          // 作業記録
          return {};
        case "UNLOADING":
          // 水揚げ
          return {};
        case "SHIPPING":
          // 加工・出荷
          return {};
        case "SEAWATER":
          // 使用海水
          return {};
        default:
          break;
      }
    },
    /**
     * メニュー画面閉じる
     */
    menuOff() {
      this.selectMenuDialog = false;
    },
  },
};
</script>

<style>
</style>
